import "core-js/modules/web.dom.iterable";

/**
 *通用表单处理器
 */
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
import { queryProjectArchtList } from '@/api/api';
export var ModalFormMixin = {
  data: function data() {
    return {
      visible: false,
      disableSubmit: false,
      model: {},
      networkStatus: true,
      //网络状态
      form_fields: [],
      form_fields_time: [],
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {},
      url: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      }
    };
  },
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          that.form_fields_time.forEach(function (item, index) {
            formData[item] = formData[item] ? formData[item].format(that.$refs[item]['format']) : null;
          }); //debugger

          console.log('formDataformData', formData);
          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
      this.$emit('ok');
    }
  },
  // 检测断网
  mounted: function mounted() {
    var _this3 = this;

    window.addEventListener("offline", function () {
      _this3.$notification_custom({
        message: '网络异常',
        type: 'error',
        duration: 0
      });

      _this3.networkStatus = false;
    });
    window.addEventListener("online", function () {
      _this3.$notification_custom({
        message: '网络已连接',
        type: 'success',
        duration: 0
      });

      _this3.networkStatus = true;
    });
  }
};